<template>
  <div class="location-form-page">
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/location' }">
        <app-i18n code="entities.location.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.location.edit.title" v-if="isEditing"></app-i18n>
        <app-i18n code="entities.location.new.title" v-if="!isEditing"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb> -->
    <app-back-button
      route-name="programSettings"
      :route-params="{ tabName: 'locations' }"
      i18n-code="entities.location.label"
    />

    <h1 class="app-content-title app-content-title--hidden">
      <app-i18n code="entities.location.edit.title" v-if="isEditing"></app-i18n>
      <app-i18n code="entities.location.new.title" v-if="!isEditing"></app-i18n>
    </h1>
    
    <div class="app-content-page">

      <div class="app-page-spinner" v-if="findLoading" v-loading="findLoading"></div>
      <el-form
        v-loading="saveLoading"
        v-if="model"
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        :model="model"
        :rules="rules"
        @submit.native.prevent="doSubmit"
        class="form"
        ref="form"
      >
        <el-form-item
          :label="fields.name.label"
          :prop="fields.name.name"
          :required="fields.name.required"
          v-if="isEditing"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input :disabled="true" ref="focus" v-model="model[fields.name.name]" />
          </el-col>
        </el-form-item>

        <!-- Search google maps -->
        <el-form-item
          :label="fields.latitude.label"
          :prop="fields.latitude.name"
          :required="fields.latitude.required && fields.longitude.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <div class="el-input el-input--prefix">
              <gmap-autocomplete
                @place_changed="setPlace"
                :value="autocomplete"
                :placeholder="i18n(`entities.location.placeholders.search`)"
                class="el-input__inner"
              ></gmap-autocomplete>
              <span class="el-input__prefix">
                <i class="el-input__icon icon-location-pin"></i>
              </span>
            </div>
            <gmap-map :center="center" :zoom="12" v-if="show" style="width: 100%; height: 400px;">
              <gmap-marker
                :key="index"
                :position="m.position"
                @click="center=m.position"
                v-for="(m, index) in markers"
              ></gmap-marker>
            </gmap-map>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.information.label"
          :prop="fields.information.name"
          :required="fields.information.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input
              :placeholder="i18n(`entities.location.placeholders.information`)"
              prefix-icon="icon-file"
              v-model="model[fields.information.name]"
            />
          </el-col>
        </el-form-item>

        <!-- <el-form-item
          :label="fields.access.label"
          :prop="fields.access.name"
          :required="fields.access.required"
        >
          <el-col :lg="12" :md="16" :sm="24">
            <el-select placeholder v-model="model[fields.access.name]">
              <el-option :value="undefined">--</el-option>
              <el-option
                :key="option.id"
                :label="option.label"
                :value="option.id"
                v-for="option in fields.access.options"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item> -->
        <!-- END Search google maps -->

        <!-- Form controls -->
        <el-form-item>
            <div class="form-buttons">

                <router-link :to="{path: '/subproperty/settings/program/locations'}">

                    <el-button class="cancel-button">
                        <app-i18n code="common.cancel" />
                    </el-button>
                
                </router-link>


                <el-button
                    :disabled="saveLoading"
                    @click="doSubmit"
                    type="primary"
                >
                    <app-i18n v-if="!isEditing" code="common.add"/>
                    <app-i18n v-if="isEditing" code="common.save" />
                </el-button>

            </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { i18n } from '@shared/i18n';
import { mapGetters, mapActions } from 'vuex';
import { FormSchema } from '@shared/form/form-schema';
import { LocationModel } from '@modules/location/location-model';

const { fields } = LocationModel;
const formSchema = new FormSchema([
  fields.id,
  fields.name,
  fields.information,
  fields.latitude,
  fields.longitude,
  // fields.access,
]);

export default {
  name: 'app-location-form-page',

  props: ['id'],

  data() {
    return {
      autocomplete: null,
      rules: formSchema.rules(),
      model: null,

      show: false, // maps
      center: { lat: 45.508, lng: -73.587 },
      markers: [],
      places: [],
      currentPlace: null,
    };
  },

  mounted() {
    this.geolocate();
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'location/form/record',
      findLoading: 'location/form/findLoading',
      saveLoading: 'location/form/saveLoading',
    }),

    isEditing() {
      return !!this.id;
    },

    fields() {
      return fields;
    },
  },

  async created() {
    if (this.isEditing) {
      await this.doFind(this.id);
      this.model = formSchema.initialValues(this.record);
      this.currentPlace = null;

      //DONE: Vaciar el currentPlace, para que a la hora de editar no se asigne la anterior ubicacion, y darle al autocomplete el valor del location.name actual
      this.autocomplete = this.record.name;
      this.addMarker();
    } else {
      this.model = formSchema.initialValues(this.record);
      this.model.information = '';
      await this.doNew();
    }
  },

  methods: {
    ...mapActions({
      doFind: 'location/form/doFind',
      doNew: 'location/form/doNew',
      doUpdate: 'location/form/doUpdate',
      doCreate: 'location/form/doCreate',
    }),

    doReset() {
      this.model = formSchema.initialValues(this.record);
    },

    async doSubmit() {
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      const { id, ...values } = formSchema.cast(this.model);

      if (this.isEditing) {
        return this.doUpdate({
          id,
          values,
        });
      } else {
        return this.doCreate(values);
      }
    },

    setPlace(place) {
      this.autocomplete = place.name;
      this.currentPlace = place;
      this.addMarker();
    },

    addMarker() {
      this.show = true;
      if (this.markers.lenght > 0) {
        this.markers = [];
      }
      var marker = {};

      if (this.currentPlace) {
        marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        this.model.name = this.currentPlace.name;
        this.places.push(this.currentPlace);
      } else {
        marker = {
          lat: Number(this.model.latitude),
          lng: Number(this.model.longitude),
        };
      }
      this.model.latitude = Number(marker.lat);
      this.model.longitude = Number(marker.lng);
      this.markers.push({ position: marker });
      this.center = marker;
    },

    geolocate: function() {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
        },
      );
    },
    i18n(code) {
      return i18n(code);
    },
  },
};
</script>

<style scoped>

.location-form-page .vue-map-container {
  margin-top: 1em;
}
.location-form-page .location-form-page__maps__autocomplete {
  width:93%;
  padding:3%;
  border: solid 1px #c5c5c5;
  border-radius: 20px;
  outline: none;
}
/* .location-form-page .location-form-page__maps__information {
  border: solid 1px #c5c5c5;
  border-radius: 20px;
} */

</style>
